export default function Marquee() {
  const text = "JIS & ISO 4210 READY • DIRECT FACTORY PRICING • SINGLE PART TO FULL CARTON • 48HR WORKSHOP DISPATCH • TRACEABLE BATCH SOURCING •";
  return (
    <section className="marquee-window" aria-label="Bicycle Parts Direct service promise" data-testid="editorial-precision-marquee">
      <div className="marquee-track"><span>{text}</span><span>{text}</span></div>
    </section>
  );
}
